// quota state management
// tracks server-reported quota and exposes helpers for UI

export function createQuotaState() {
  let quota = null;

  function setQuota(data) {
    quota = data && typeof data === "object" ? data : null;
  }

  function getQuota() {
    return quota;
  }

  function isLoaded() {
    return quota != null;
  }

  function isAdmin() {
    return Boolean(quota?.is_admin);
  }

  function isOverQuota() {
    if (!quota) return false;
    if (isAdmin()) return false;
    return getUsedPlusQueuedMinutes() >= getHardLimitMinutes();
  }

  function isNearingLimit() {
    if (!quota) return false;
    if (isAdmin()) return false;
    const usedPlusQueued = getUsedPlusQueuedMinutes();
    return usedPlusQueued >= getIncludedMinutes() && !isOverQuota();
  }

  function getUsedMinutes() {
    return normalizeQuotaNumber(quota?.used_minutes, 0);
  }

  function getQueuedMinutes() {
    return normalizeQuotaNumber(quota?.queued_minutes, 0);
  }

  function getIncludedMinutes() {
    return normalizeQuotaNumber(quota?.included_minutes, 720);
  }

  function getGraceMinutes() {
    return normalizeQuotaNumber(quota?.grace_minutes, 0);
  }

  function getHardLimitMinutes() {
    return normalizeQuotaNumber(
      quota?.hard_limit_minutes,
      getIncludedMinutes() + getGraceMinutes(),
    );
  }

  function getUsedPlusQueuedMinutes() {
    return getUsedMinutes() + getQueuedMinutes();
  }

  return {
    setQuota,
    getQuota,
    isLoaded,
    isAdmin,
    isOverQuota,
    isNearingLimit,
    getUsedMinutes,
    getQueuedMinutes,
    getUsedPlusQueuedMinutes,
    getIncludedMinutes,
    getGraceMinutes,
    getHardLimitMinutes,
  };
}

function normalizeQuotaNumber(value, fallback) {
  const num = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(num)) return fallback;
  return Math.max(0, Math.floor(num));
}
